<template>
  <div>
    <h5>{{ labels.burgStaat.objectName }}</h5>
    <select-input v-model="gezin.burgStaat.burgstaat"
                  @input="isBurgStaatDirty = true"
                  id="pLidBurgstand"
                  label="Burgerlijke staat"
                  :is-dirty="gezin.burgStaat.burgstaat != cache.burgStaat.burgstaat"
                  :select-values="burgStanden"
                  :info="infoForBurgstaat('burgstaat')"
                  :is-disabled="disabledFieldsMap.burgStaat.burgstaat"
                  @close="updateHasPartner">
    </select-input>

    <date-input v-model="gezin.burgStaat.burgstaatDatum"
                id="burgStaatRefDate"
                :label="labels.burgStaat.burgstaatDatum"
                placeholder="Referentiedatum voor deze burgerlijke staat"
                :is-dirty="false"
                :is-invalid="$v.gezin.burgStaat.burgstaatDatum.$invalid">
    </date-input>
    <date-input v-model="gezin.burgStaat.huwelijksdatum"
                id="huwelijksdatumRefDate"
                :label="labels.burgStaat.huwelijksdatum"
                placeholder="Huwelijksdatum / datum wettelijk samenwonend"
                :is-dirty="false"
                :is-invalid="$v.gezin.burgStaat.huwelijksdatum.$invalid">
    </date-input>

    <div>
      <h5>{{ labels.partner.objectName }}</h5>
      <text-input v-model.trim="$v.gezin.partner.naam.$model"
                  id="pLidPartnerNaam"
                  :label="labels.partner.naam"
                  :is-dirty="partner.naam != cache.partner.naam"
                  :validation-object="$v.gezin.partner.naam"
                  :info="infoForPartner('naam')"
                  :is-disabled="disabledFieldsMap.partner.naam"
                  @input="onPartnerUpdate">
      </text-input>
      <text-input v-model.trim="$v.gezin.partner.voornaam.$model"
                  id="pLidPartnerVoornaam"
                  :label="labels.partner.voornaam"
                  :is-dirty="partner.voornaam != cache.partner.voornaam"
                  :validation-object="$v.gezin.partner.voornaam"
                  :info="infoForPartner('voornaam')"
                  :is-disabled="disabledFieldsMap.partner.voornaam"
                  @input="onPartnerUpdate">
      </text-input>
      <nationality-input v-if="!hiddenFieldsMap.partner.nationaliteit"
                         v-model="$v.gezin.partner.nationaliteit.$model"
                         id="partnerNatio"
                         :label="labels.partner.nationaliteit"
                         :is-dirty-natio="$v.gezin.partner.nationaliteit.$dirty"
                         :show-delete="false"
                         :info="infoForPartner('nationaliteit')"
                         :is-disabled="disabledFieldsMap.partner.nationaliteit.nationaliteit"
                         :has-type="false">
      </nationality-input>
      <date-input v-model="partner.geboortedatum"
                  id="pLidPartnerGeboortedatum"
                  :label="labels.partner.geboortedatum"
                  :is-dirty="partner.geboortedatum != cache.partner.geboortedatum"
                  :required="$v.gezin.partner.geboortedatum.hasOwnProperty('required')"
                  :info="infoForPartner('geboortedatum')"
                  :is-disabled="disabledFieldsMap.partner.geboortedatum"
                  @input="onPartnerUpdate">
      </date-input>
      <text-input v-if="!hiddenFieldsMap.partner.geboorteplaats"
                  v-model.trim="$v.gezin.partner.geboorteplaats.$model"
                  id="pLidPartnerGeboorteplaats"
                  :label="labels.partner.geboorteplaats"
                  :is-dirty="partner.geboorteplaats != cache.partner.geboorteplaats"
                  :validation-object="$v.gezin.partner.geboorteplaats"
                  :info="infoForPartner('geboorteplaats')"
                  :is-disabled="disabledFieldsMap.partner.geboorteplaats"
                  @input="onPartnerUpdate">
      </text-input>
      <yes-no-input v-model="$v.gezin.partner.mindervalide.$model"
                    id="pLidPartnerMindervalide"
                    name="PartnerMindervalideRadio"
                    :label="labels.partner.mindervalide"
                    :info="infoForPartner('mindervalide')"
                    :is-disabled="disabledFieldsMap.partner.mindervalide"
                    :is-dirty="partner.mindervalide != cache.partner.mindervalide">
      </yes-no-input>
      <yes-no-input v-model="$v.gezin.partner.tenLaste.$model"
                    id="pLidPartnerTenLaste"
                    name="partnerTenLasteRadio"
                    :label="labels.partner.tenLaste"
                    :info="infoForPartner('tenLaste')"
                    :is-disabled="disabledFieldsMap.partner.tenLaste"
                    :is-dirty="partner.tenLaste != cache.partner.tenLaste">
      </yes-no-input>
      <text-input v-model.trim="$v.gezin.partner.beroep.$model"
                  id="pLidPartnerBeroep"
                  :label="labels.partner.beroep"
                  :is-dirty="partner.beroep != cache.partner.beroep"
                  :validation-object="$v.gezin.partner.beroep"
                  :info="infoForPartner('beroep')"
                  :is-disabled="disabledFieldsMap.partner.beroep"
                  @input="onPartnerUpdate">
      </text-input>
      <text-input v-if="!hiddenFieldsMap.partner.werkgever"
                  v-model.trim="$v.gezin.partner.werkgever.$model"
                  id="pLidPartnerWerkgever"
                  :label="labels.partner.werkgever"
                  :is-dirty="partner.werkgever !== cache.partner.werkgever"
                  :validation-object="$v.gezin.partner.werkgever"
                  :info="infoForPartner('werkgever')"
                  :is-disabled="disabledFieldsMap.partner.werkgever"
                  @input="onPartnerUpdate">
      </text-input>
      <date-input v-model.trim="$v.gezin.partner.partnOverlijdensdatum.$model"
                  id="pLidPartnerOverlijdensdatum"
                  :required="
          $v.gezin.partner.partnOverlijdensdatum.hasOwnProperty('required')
        "
                  :label="labels.partner.overlijdensdatum"
                  :info="infoForPartner('overlijdensdatum')"
                  :is-disabled="disabledFieldsMap.partner.overlijdensdatum"
                  @input="onPartnerUpdate"
                  :is-dirty="
          partner.partnOverlijdensdatum != cache.partner.partnOverlijdensdatum
        "></date-input>
    </div>
    <h5 v-if="gezin.gezinsleden.length == 1">
      {{ labels.gezinsleden.objectName.singular }}
    </h5>
    <h5 v-else>{{ labels.gezinsleden.objectName.plural }}</h5>
    <div class="table-responsive d-flex justify-content-center">
      <table v-if="gezin.gezinsleden.length != 0"
             class="table table-striped card-title">
        <thead>
          <tr>
            <th scope="col">{{ labels.gezinsleden.verwantschap }}</th>
            <th scope="col">{{ labels.gezinsleden.naam }}</th>
            <th scope="col">{{ labels.gezinsleden.voornaam }}</th>
            <th scope="col">{{ labels.gezinsleden.geboortedatum }}</th>
            <th scope="col">{{ labels.gezinsleden.tenLaste }}</th>
            <th scope="col">{{ labels.gezinsleden.nietMeerTenLaste }}</th>
            <th scope="col">{{ labels.gezinsleden.mindervalide }}</th>
            <th scope="col">{{ labels.gezinsleden.zorgbehoevend }}</th>
            <th scope="col">{{ labels.gezinsleden.overlijdensdatum }}</th>
            <th scope="col">Acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(gezinslid, index) in gezin.gezinsleden"
              :key="'tr-gezinslid-' + parseInt(index)">
            <td v-if="gezinslid.verwantschap">{{ gezinslid.verwantschap }}</td>
            <td v-if="gezinslid.verwantschap == ''">?</td>

            <td>{{ gezinslid.naam }}</td>
            <td>{{ gezinslid.voornaam }}</td>
            <td>{{ gezinslid.geboortedatum }}</td>

            <td v-if="gezinslid.tenLaste">Ja</td>
            <td v-if="!gezinslid.tenLaste">Nee</td>

            <td v-if="gezinslid.nietMeerTenLaste">
              {{ gezinslid.nietMeerTenLaste }}
            </td>
            <td v-if="
                gezinslid.nietMeerTenLaste == null ||
                  gezinslid.nietMeerTenLaste == ''
              ">
              /
            </td>
            <td>{{ gezinslid.mindervalide ? "Ja" : "Nee" }}</td>
            <td>{{ gezinslid.zorgbehoevend ? "Ja" : "Nee" }}</td>
            <td v-if="gezinslid.overlijdensdatum != null">
              {{ gezinslid.overlijdensdatum }}
            </td>
            <td v-if="gezinslid.overlijdensdatum == null">/</td>
            <td class="text-left">
              <edit-button @click="editGezinslid(index)"></edit-button>
              <delete-button @click="deleteGezinslid(index)"></delete-button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 v-if="gezin.gezinsleden.length == 0">
        Geen gezinsleden. U kan gezinsleden toevoegen met onderstaande knop.
      </h5>
    </div>
    <div class="text-center">
      <button v-tooltip="'Gezinslid toevoegen'"
              :disabled="isCurrentlyEditingGezinslid"
              @click="addGezinslid()"
              type="button"
              class="btn btn-success btn-sm">
        <font-awesome-icon :icon="['fad', 'user-plus']"></font-awesome-icon>
      </button>
    </div>
    <div v-if="isCurrentlyEditingGezinslid">
      <h5 v-if="isNewGezinslid">Nieuw gezinslid toevoegen</h5>
      <h5 v-else>Bewerk gezinslid</h5>
      <select-input v-model="$v.currentlyEditingGezinslid.verwantschap.$model"
                    id="pLidEditingVerwantschap"
                    :label="labels.gezinsleden.verwantschap"
                    :is-dirty="$v.currentlyEditingGezinslid.verwantschap.$dirty"
                    :required="
          $v.currentlyEditingGezinslid.verwantschap.hasOwnProperty('required')
        "
                    :select-values="verwantschappen"
                    :info="infoForGezinsleden('verwantschap')"
                    :is-disabled="disabledFieldsMap.gezinsleden.verwantschap">
      </select-input>
      <text-input v-model="$v.currentlyEditingGezinslid.naam.$model"
                  id="pLidEditingGezezinslidNaam"
                  :label="labels.gezinsleden.naam"
                  :is-dirty="$v.currentlyEditingGezinslid.naam.$dirty"
                  :info="infoForGezinsleden('naam')"
                  :is-disabled="disabledFieldsMap.gezinsleden.naam"
                  :validation-object="$v.currentlyEditingGezinslid.naam">
      </text-input>
      <text-input v-model="$v.currentlyEditingGezinslid.voornaam.$model"
                  id="pLidEditingVoornaam"
                  :label="labels.gezinsleden.voornaam"
                  :is-dirty="$v.currentlyEditingGezinslid.voornaam.$dirty"
                  :info="infoForGezinsleden('voornaam')"
                  :is-disabled="disabledFieldsMap.gezinsleden.voornaam"
                  :validation-object="$v.currentlyEditingGezinslid.voornaam">
      </text-input>
      <date-input v-model="currentlyEditingGezinslid.geboortedatum"
                  id="pLidEditingGeboortedatum"
                  :required="
          $v.currentlyEditingGezinslid.geboortedatum.hasOwnProperty('required')
        "
                  :label="labels.gezinsleden.geboortedatum"
                  :info="infoForGezinsleden('geboortedatum')"
                  :is-disabled="disabledFieldsMap.gezinsleden.geboortedatum"
                  :is-dirty="$v.currentlyEditingGezinslid.geboortedatum.$dirty">
      </date-input>
      <yes-no-input v-model="currentlyEditingGezinslid.mindervalide"
                    name="curGezinslidMindervalideRadio"
                    id="pLidEditingMindervalide"
                    :label="labels.gezinsleden.mindervalide"
                    :info="infoForGezinsleden('mindervalide')"
                    :is-disabled="disabledFieldsMap.gezinsleden.mindervalide"
                    :is-dirty="$v.currentlyEditingGezinslid.mindervalide.$dirty">
      </yes-no-input>
      <yes-no-input v-model="currentlyEditingGezinslid.zorgbehoevend"
                    name="curGezinslidZorgbehoevendRadio"
                    id="pLidEditingZorgbehoevend"
                    :label="labels.gezinsleden.zorgbehoevend"
                    :info="infoForGezinsleden('zorgbehoevend')"
                    :is-disabled="disabledFieldsMap.gezinsleden.zorgbehoevend"
                    :is-dirty="$v.currentlyEditingGezinslid.zorgbehoevend.$dirty">
      </yes-no-input>
      <yes-no-input v-model="currentlyEditingGezinslid.tenLaste"
                    id="pLidEditingTenLaste"
                    name="curGezinslidTenLasteRadio"
                    :label="labels.gezinsleden.tenLaste"
                    :info="infoForGezinsleden('tenLaste')"
                    :is-disabled="disabledFieldsMap.gezinsleden.tenLaste"
                    :is-dirty="$v.currentlyEditingGezinslid.tenLaste.$dirty">
      </yes-no-input>
      <date-input v-if="currentlyEditingGezinslid.tenLaste == false"
                  v-model="currentlyEditingGezinslid.nietMeerTenLaste"
                  :required="
          $v.currentlyEditingGezinslid.nietMeerTenLaste.hasOwnProperty(
            'required'
          )
        "
                  id="pLidEditingGezinslidNMTL"
                  :label="labels.gezinsleden.nietMeerTenLaste"
                  :info="infoForGezinsleden('nietMeerTenLaste')"
                  :is-disabled="disabledFieldsMap.gezinsleden.nietMeerTenLaste"
                  :is-dirty="$v.currentlyEditingGezinslid.nietMeerTenLaste.$dirty">
      </date-input>
      <date-input v-model="currentlyEditingGezinslid.overlijdensdatum"
                  id="pLidEditingGezinslidOverlijdensdatum"
                  :required="$v.currentlyEditingGezinslid.hasOwnProperty('required')"
                  :label="labels.gezinsleden.overlijdensdatum"
                  :info="infoForGezinsleden('overlijdensdatum')"
                  :is-disabled="disabledFieldsMap.gezinsleden.overlijdensdatum"
                  :is-dirty="false">
      </date-input>
      <div class="row justify-content-md-center">
        <div class="mr-2">
          <button @click="completeEditingGezinslid()"
                  type="button"
                  class="btn btn-success btn-sm"
                  :disabled="$v.currentlyEditingGezinslid.$invalid || curEditGezinslidInvalid">
            Gereed
          </button>
        </div>
        <div>
          <button @click="cancelEditingGezinslid()"
                  type="button"
                  class="btn btn-warning btn-sm">
            Annuleren
          </button>
        </div>
      </div>
    </div>
    <div class="pt-2 mt-3 border-top">
      <label class="font-weight-bold">Opmerking:</label>
      <textarea @input="onRemarkChange"
                v-model="currentRemark"
                rows="3"
                class="form-control mb-2"
                placeholder="Opmerking"
                type="text"></textarea>
    </div>
    <file-upload label="Bewijsstuk(ken) uploaden:"
                 :upload-percentage="0"
                 @files-changed="onFilesChanged"></file-upload>
  </div>
</template>

<script>
  import diff from "deep-diff";
  import { maxLength, required, requiredIf } from "vuelidate/lib/validators";
  import DossierLabels from "./../DossierLabels.js";
  import { dateValidator } from "./../../utils/DateUtils.js";
  import {
    proofValidator,
    proofSuppliedIfNeeded
  } from "../../utils/DossierUtils.js";
  import TextInput from "./../../inputs/TextInput.vue";
  import SelectInput from "./../../inputs/SelectInput.vue";
  import NationalityInput from "./../../inputs/NationalityInput.vue";
  import DateInput from "./../../inputs/DateInput.vue";
  import YesNoInput from "./../../inputs/YesNoRadials.vue";
  import DeleteButton from "./../../interface/DeleteButton.vue";
  import EditButton from "./../../interface/EditButton.vue";
  import FileUpload from "./../../inputs/FileUpload.vue";
  import { RepositoryFactory } from "./../../repositories/RepositoryFactory";
  const FamilyRepository = RepositoryFactory.get("family");

  export default {
    name: "gezin-form",
    props: {
      gezin: {
        type: Object
      },
      cache: {
        type: Object
      },
      remark: {
        type: String
      },
      attachments: {
        type: Array,
        required: false
      },
      disabledFieldsMap: {
        type: Object
      },
      proofRequiredFieldsMap: {
        type: Object
      },
      proofInfoFieldsMap: {
        type: Object
      },
      hiddenFieldsMap: {
        type: Object
      }
    },
    components: {
      TextInput,
      SelectInput,
      NationalityInput,
      DateInput,
      YesNoInput,
      EditButton,
      DeleteButton,
      FileUpload
    },
    data() {
      return {
        labels: DossierLabels.gezin,
        currentlyEditingGezinslid: {},
        currentlyEditingGezinslidIndex: null,
        partner: this.gezin.partner,
        isNewGezinslid: false,
        burgStanden: [],
        verwantschappen: [],
        currentRemark: this.remark,
        currentAttachments: this.attachments,
        hasPartner: true,
        isBurgStaatDirty: false
      };
    },
    created() {
      this.getBurgStanden();
      this.getVerwantschappen();
      this.onPartnerUpdate();
      this.updateHasPartner();
    },
    methods: {
      onPartnerUpdate() {
        this.$emit("update-partner", this.partner);
      },
      addGezinslid() {
        this.currentlyEditingGezinslid = {
          id: 0,
          naam: "",
          voornaam: "",
          geboortedatum: null,
          overlijdensdatum: null,
          mindervalide: false,
          zorgbehoevend: false,
          tenLaste: false,
          nietMeerTenLaste: null,
          verwantschap: ""
        };
        this.editGezinslid("new");
      },
      updateHasPartner() {
        let value = this.gezin.burgStaat.burgstaat;
        this.hasPartner =
          value == "Gehuwd" ||
          value == "Gehuwd met haardgeld" ||
          value == "Wettelijk samenwonend" ||
          value == "Wettelijk samenwonend met haardgeld";
      },
      editGezinslid(index) {
        if (index == "new") {
          this.isNewGezinslid = true;
        } else {
          this.currentlyEditingGezinslid = JSON.parse(JSON.stringify(this.gezin.gezinsleden[index]));
          this.currentlyEditingGezinslidIndex = index;
        }
      },
      completeEditingGezinslid() {
        if (this.isNewGezinslid) {
          this.gezin.gezinsleden.push(this.currentlyEditingGezinslid);
          this.currentlyEditingGezinslid = {};
          this.currentlyEditingGezinslidIndex = null;
          this.isNewGezinslid = false;
        } else {
          this.gezin.gezinsleden[
            this.currentlyEditingGezinslidIndex
          ] = JSON.parse(JSON.stringify(this.currentlyEditingGezinslid));
          this.currentlyEditingGezinslid = {};
          this.currentlyEditingGezinslidIndex = null;
        }
      },
      cancelEditingGezinslid() {
        this.currentlyEditingGezinslid = {};
        this.currentlyEditingGezinslidIndex = null;
      },
      deleteGezinslid(index) {
        if (this.gezin.gezinsleden[index] == this.currentlyEditingGezinslid) {
          this.completeEditingGezinslid();
        }
        this.gezin.gezinsleden.splice(index, 1);
      },
      isDiffToCache(newValue, cachedValue) {
        let parsedValue = JSON.parse(JSON.stringify(newValue));
        return diff(cachedValue, parsedValue) != undefined;
      },
      async getBurgStanden() {
        const { data } = await FamilyRepository.getBurgStanden();
        this.burgStanden = data.map(burgstand => burgstand.burgstand);
      },
      async getVerwantschappen() {
        const { data } = await FamilyRepository.getVerwantschappen();
        this.verwantschappen = data.map(
          verwantschap => verwantschap.verwantschap
        );
      },
      onFilesChanged(value) {
        this.currentAttachments = value;
        this.$emit("files-changed", this.currentAttachments);
      },
      onRemarkChange() {
        this.$emit("remark-changed", this.currentRemark);
      },
      isFieldUpdated(fieldName) {
        let parsedValue = JSON.parse(JSON.stringify(this.gezin[fieldName]));
        return this.isDiffToCache(parsedValue, this.cache[fieldName]);
      },
      isPartnerFieldUpdated(fieldName) {
        let parsedValue = JSON.parse(JSON.stringify(this.gezin[fieldName]));
        return this.isDiffToCache(parsedValue, this.cache[fieldName]);
      },
      infoForInput(valueName) {
        if (this.proofRequiredFieldsMap[valueName]) {
          if (this.proofInfoFieldsMap[valueName] != "") {
            return this.proofInfoFieldsMap[valueName];
          }
          return "Bewijsstuk vereist om dit veld aan te passen.";
        } else {
          return null;
        }
      },
      infoForPartner(valueName) {
        if (this.proofRequiredFieldsMap.partner[valueName]) {
          if (this.proofInfoFieldsMap.partner[valueName] != "") {
            return this.proofInfoFieldsMap.partner[valueName];
          }
          return "Bewijsstuk vereist om dit veld aan te passen.";
        } else {
          return null;
        }
      },
      infoForBurgstaat(valueName) {
        if (this.proofRequiredFieldsMap.burgStaat[valueName]) {
          if (this.proofInfoFieldsMap.burgStaat[valueName] != "") {
            return this.proofInfoFieldsMap.burgStaat[valueName];
          }
          return "Bewijsstuk vereist om dit veld aan te passen.";
        } else {
          return null;
        }
      },
      infoForGezinsleden(valueName) {
        if (this.proofRequiredFieldsMap.gezinsleden[valueName]) {
          if (this.proofInfoFieldsMap.gezinsleden[valueName] != "") {
            return this.proofInfoFieldsMap.gezinsleden[valueName];
          }
          return "Bewijsstuk vereist om dit veld aan te passen.";
        } else {
          return null;
        }
      }
    },
    computed: {
      isCurrentlyEditingGezinslid() {
        return Object.keys(this.currentlyEditingGezinslid).length != 0;
      },

      curEditGezinslidInvalid() {
        if (this.currentAttachments && this.currentAttachments.length > 0) {
          return false;
        }
        var cur = this.currentlyEditingGezinslid;
        var rfm = this.proofRequiredFieldsMap.gezinsleden;
        if (cur.id !== 0) {
          var ori = this.gezin.gezinsleden[this.currentlyEditingGezinslidIndex];
          for (const prop of ["mindervalide", "zorgbehoevend", "tenLaste"]) {
            if (rfm[prop] && cur[prop] && !ori[prop]) {
              return true;
            }
          }
        } else {
          for (const prop of ["mindervalide", "zorgbehoevend", "tenLaste"]) {
            if (rfm[prop] && cur[prop]) {
              return true;
            }
          }
          if (rfm['verwantschap']) { return true; }
        }
        return false;
      },

      doesFormRequireProof() {
        return Object.values(this.proofRequiredFieldsMap).indexOf(true) > -1;
      },
      isBurgstaatChanged() {
        return this.gezin.burgStaat.burgstaat != this.cache.burgStaat.burgstaat;
      }
    },
    validations() {
      if (this.hasPartner) {
        if (this.isCurrentlyEditingGezinslid) {
          return {
            gezin: {
              partner: {
                proofValidator: proofSuppliedIfNeeded(
                  this.proofRequiredFieldsMap.partner,
                  this.isFieldUpdated("partner"),
                  this.currentAttachments
                ),
                naam: {
                  required,
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.partner.naam,
                    this.isFieldUpdated("partner"),
                    this.currentAttachments
                  )
                },
                voornaam: {
                  required
                },
                nationaliteit: {
                  nationaliteit: {
                    required
                  },
                  natCode: {
                    required
                  }
                },
                mindervalide: {
                  required
                },
                tenLaste: {
                  required
                },                
                geboortedatum: {
                  required
                },
                geboorteplaats: {
                  required
                },
                beroep: {
                  required,
                  maxLength: maxLength(48)
                },
                werkgever: {
                  maxLength: maxLength(30)
                },
                partnOverlijdensdatum: {
                  dateValidator
                }
              },
              burgStaat: {
                burgstaat: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  )
                },
                burgstaatDatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                },
                huwelijksdatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                }
              }
            },
            currentlyEditingGezinslid: {
              naam: {
                required
              },
              voornaam: {
                required
              },
              geboortedatum: {
                dateValidator
              },
              overlijdensdatum: {
                dateValidator
              },
              mindervalide: {
                required
              },
              zorgbehoevend: {
                required
              },
              tenLaste: {
                required
              },
              nietMeerTenLaste: {},
              verwantschap: {
                required
              }
            }
          };
        } else {
          return {
            gezin: {
              partner: {
                naam: {
                  required
                },
                voornaam: {
                  required
                },
                nationaliteit: {
                  nationaliteit: {
                    required
                  },
                  natCode: {
                    required
                  }
                },
                geboortedatum: {
                  required
                },
                geboorteplaats: {
                  required
                },
                mindervalide: {
                  required
                },
                tenLaste: {
                  required
                },                
                beroep: {
                  required,
                  maxLength: maxLength(48)
                },
                werkgever: {
                  maxLength: maxLength(30)
                },
                partnOverlijdensdatum: {
                  dateValidator
                }
              },
              burgStaat: {
                burgstaat: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  )
                },
                burgstaatDatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                },
                huwelijksdatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                }
              }
            }
          };
        }
      } else {
        if (this.isCurrentlyEditingGezinslid) {
          return {
            gezin: {
              partner: {
                naam: {},
                voornaam: {},
                nationaliteit: {
                  nationaliteit: {},
                  natCode: {}
                },
                geboortedatum: {},
                geboorteplaats: {},
                beroep: {},
                werkgever: {},
                mindervalide: {},
                tenLaste: {},
                partnOverlijdensdatum: {}
              },
              burgStaat: {
                burgstaat: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  )
                },
                burgstaatDatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                },
                huwelijksdatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                }
              }
            },
            currentlyEditingGezinslid: {
              naam: {
                required
              },
              voornaam: {
                required
              },
              geboortedatum: {
                dateValidator
              },
              overlijdensdatum: {
                dateValidator
              },
              mindervalide: {
                required
              },
              zorgbehoevend: {
                required
              },
              tenLaste: {
                required
              },
              nietMeerTenLaste: {},
              verwantschap: {
                required
              }
            }
          };
        } else {
          return {
            gezin: {
              partner: {
                naam: {},
                voornaam: {},
                nationaliteit: {
                  nationaliteit: {},
                  natCode: {}
                },
                geboortedatum: {},
                geboorteplaats: {},
                beroep: {},
                werkgever: {},
                mindervalide: {},
                tenLaste: {},
                partnOverlijdensdatum: {}
              },
              burgStaat: {
                burgstaat: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  )
                },
                burgstaatDatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                },
                huwelijksdatum: {
                  proofValidator: proofSuppliedIfNeeded(
                    this.proofRequiredFieldsMap.burgstnd,
                    this.isFieldUpdated("burgStaat"),
                    this.currentAttachments
                  ),
                  required: requiredIf(function () {
                    return this.isBurgstaatChanged;
                  })
                }
              }
            }
          };
        }
      }
    },
    watch: {
      $v: {
        handler(value) {
          this.$emit("validation-change", value.$invalid);
        },
        deep: true
      }
    }
  };
</script>

<style scoped></style>
